import React, { useState, useEffect } from "react";
import path from "path";
import Resizer from "react-image-file-resizer";

import services from "../../services";
import moment from "moment";

import {
  adicionarArquivo,
  uploadArquivoAzure,
} from "../../services/http/arquivoServico";

import {
  criarPasta,
  editarPastaUpload,
  verificarDuplacidade,
} from "../../services/http/pastaService";

import { uploadAzure } from "../../services/azureblobsService";

import { calcularTamanhoArquivo } from "../../services/utils";

import { Modal, Tree, message, Upload } from "antd";

import { SearchOutlined } from "@ant-design/icons";

import pastaSvg from "../../assets/icons/infoPasta.svg";
import pastaSvgFechada from "../../assets/icons/pasta-menu.svg";
import infoArquivoSvg from "../../assets/icons/infoArquivo.svg";
import iconNuvemArquivoSvg from "../../assets/icons/iconNuvemArquivo.svg";
import "./styles.scss";
import { v4 as uuidv4 } from "uuid";
import globals from "../../globlas";
import { CloseOutlined } from "@mui/icons-material";
import icAtencao from "../../assets/icons/atencaoIcon.svg";
const { Dragger } = Upload;
const AZURE_URL_BLOB = globals.REACT_APP_AZURE_URL_BLOB;

const ModalUpload = ({
  closeModal,
  showModal,
  destino,
  openModal,
  buscarPastasFilhas,
  setShowTreeData,
  setLoading,
  loading,
  setCloseOpenModal,
}) => {

  const data = new Date(); // momento atual
  const horas = data.getHours().toString();
  const minutos = data.getMinutes().toString();

  const hhmmm = [horas, minutos].join(":");

  const { IdUser, login, IsAdmin } = services.storage.getUser();
  const [progressoUpload, setProgressoUpload] = useState(0);
  const [showProgresso, setShowProgresso] = useState(false);
  const [showUpload, setShowUpload] = useState(true);
  const [uploadFinalizar, setUploadFinalizar] = useState(false);
  const [objetoFinalizar, setObjetoFinalizar] = useState(null);
  const [arquivoDuplicado, setArquivoDuplicado] = useState(false);
  const [botaoParamimTodos, setBotaoParamimTodos] = useState(Boolean);
  const [dataVencimentoInicial, setDataVencimentoInicial] = useState(
    moment().format("YYYY-MM-DD")
  );
  const [dataVencimentoFinal, setDataVencimentoFinal] = useState("");
  const [horaInicial, setHoraInicial] = useState(hhmmm);
  const [horaFinal, setHoraFinal] = useState("");
  const [treeItens, setTreeItens] = useState([
    {
      title: destino ? destino.nome : "Nuvem de arquivos",
      key: destino ? destino.id : "0",
      icon: <img src={pastaSvgFechada} />,
    },
  ]);
  const [listaPastaArquivosCriados, setListaPastaArquivosCriados] = useState(
    []
  );
  const [listaArquivos, setListaArquivos] = useState([]);
  const [listaTotal, setListaTotal] = useState([]);
  const [count, setCount] = useState(1);

  useEffect(() => {
    setListaArquivos([]);
    setListaTotal([]);
    setShowProgresso(false);
    setObjetoFinalizar({});
    setListaPastaArquivosCriados([]);
  }, []);

  const handleUploadProgress = (e, total) => {
    setShowProgresso(true);
    let porcentagem = Math.floor((e * 100) / total);

    if (porcentagem >= 0) {
      setProgressoUpload(porcentagem);
    }
  };

  const finalizarUpload = async (publicarParaMim, substituir) => {
    setLoading(true);

    // validações
    var data_dataVencimentoInicial = dataVencimentoInicial;
    var data_dataVencimentoFinal = dataVencimentoFinal;

    if (!data_dataVencimentoInicial) {
      message.warning("Informe a data inicial.");
      setLoading(false);
      return;
    }

    if (!data_dataVencimentoFinal && horaFinal) {
      message.warning("Informe a data final.");
      setLoading(false);
      return;
    }

    if (horaInicial) data_dataVencimentoInicial += " " + horaInicial;

    if (data_dataVencimentoFinal && horaFinal)
      data_dataVencimentoFinal += " " + horaFinal;

    if (moment(data_dataVencimentoInicial).isAfter(data_dataVencimentoFinal)) {
      message.warning("A data inicial não pode ser depois da data final.");
      setLoading(false);
      return;
    }

    // início do processo
    setBotaoParamimTodos(publicarParaMim);

    const arrayArquivos = [];
    for (const arq of listaPastaArquivosCriados) {
      if (arq.nome.includes(".")) {
        arrayArquivos.push(arq);
      } else {
        // pasta
        const data = {
          nomePasta: arq.nome,
          autor:login,
          idPasta: arq.id,
          idParent: arq.idParent,
          dataVencimentoInicial: data_dataVencimentoInicial,
          dataVencimentoFinal: data_dataVencimentoFinal,
          IdUsuarioOcultou: publicarParaMim ? IdUser : null,
        };
        await editarPastaUpload(data);
      }
    }

    for (const arquivo of arrayArquivos) {
      if (!substituir) {
        let ret = await verificarDuplacidade(
          arquivo.nome,
          arquivo.idParent ? arquivo.idParent : ""
        );

        if (ret?.data === true) {
          setArquivoDuplicado(true);
          setLoading(false);
          return;
        }
      }
   
      const data = {
        idPasta: arquivo.idParent,
        classificacao: 0,
        autor: login,
        tamanho: calcularTamanhoArquivo(arquivo.tamanho),
        nomeArquivo: arquivo.nome,
        urlArquivo: arquivo.urlArquivo,
        path: arquivo.path ? arquivo.path : null,
        extensao: arquivo.extensao,
        nomeOriginal: arquivo.nomeOriginal,
        tipoMidia: arquivo.tipo,
        urlPreview: arquivo.urlPreview,
        idUsuarioOcultou: publicarParaMim ? IdUser : null,
        dataVencimentoInicial: data_dataVencimentoInicial,
        dataVencimentoFinal: data_dataVencimentoFinal,
        tamanhoEmBytes: arquivo.tamanho,
      };

      await adicionarArquivo(data);
    }

    message.success("Upload finalizado com sucesso!");
    setLoading(false);
    if (destino != null && destino.id != null) {
      buscarPastasFilhas(destino.id, "pasta", destino.nome);
    } else {
      buscarPastasFilhas("0", "pasta", "NuvemArquivo");
    }
    setShowTreeData(false);
    setTimeout(() => {
      setShowTreeData(true);
    }, 2);
    closeModal();
  };

  const selectItem = (e) => {
    const findArquivo = listaPastaArquivosCriados.find((item) => {
      return item.nome.includes(".") && item.nome == e;
    });

    if (findArquivo != null && findArquivo != undefined) {
      setObjetoFinalizar(findArquivo);
    }
  };

  const handleOnExpand = (e) => {};

  const updateTreeData = (list, key, children) => {
    return list.map((node) => {
      if (node.key === key) {
        return { ...node, children };
      }

      if (node.children) {
        return {
          ...node,
          children: updateTreeData(node.children, key, children),
        };
      }

      return node;
    });
  };

  const incluirNovaPasta = async (nome, idParent) => {
    const pastaJaCriadaIndex = listaPastaArquivosCriados.findIndex(
      (item) => item.nome == nome
    );

    if (pastaJaCriadaIndex >= 0) {
      return listaPastaArquivosCriados[pastaJaCriadaIndex].id;
    } else {
      var nomeTrim = nome.split("###")[0].trim();
      let data = {
        nomePasta: nomeTrim,
        idParent: idParent,
        classificacao: 0,
        autor: login,
        tamanho: 0,
        tipoDocumento: 0,
        idParent: idParent,
        EhUpload: true,
      };

      const res = await criarPasta(data);

      if (!res.fail && res.data) {
        let pastaCriada = {
          id: res.data.id,
          nome: nome,
          idParent: idParent,
        };

        listaPastaArquivosCriados.push(pastaCriada);
        setListaPastaArquivosCriados(listaPastaArquivosCriados);

        return pastaCriada.id;
      } else {
        console.error("criar-pasta-upload", res.errors);
      }
    }
  };

  const incluirNovoArquivo = (
    nome,
    idParent,
    tamanho,
    urlArquivo,
    path,
    tipo,
    nomeOriginal,
    extensao,
    urlPreview
  ) => {
    const arquivosJaCriadosIndex = listaPastaArquivosCriados.findIndex(
      (item) =>
        (item.nome == nome && item.idParent == idParent) ||
        (item.nome == nome && item.idParent == null)
    );

    if (arquivosJaCriadosIndex < 0) {
      let arquivoCriado = {
        id: nome,
        nome: nome,
        idParent: idParent,
        tamanho: tamanho,
        urlArquivo: urlArquivo,
        path: path,
        tipo: tipo,
        nomeOriginal: nomeOriginal,
        extensao: extensao,
        urlPreview: urlPreview,
      };

      listaPastaArquivosCriados.push(arquivoCriado);
      setListaPastaArquivosCriados(listaPastaArquivosCriados);
    }
  };

  var contador = 0;
  const monstarUploadFinalizacao = async () => {
    let idParent = destino ? destino.id : null;

    var pastaAntes = String(listaArquivos[0].nome).split("/");
    var pastaDepois = String(listaArquivos[0].nome).split("/");

    pastaAntes.pop();
    pastaDepois.pop();
    for (const arq of listaArquivos) {
      let arrayArqPastas = String(arq.nome).split("/");
      pastaDepois = String(arq.nome).split("/");
      pastaDepois.pop();

      var newArray = [];
      for (var i = 0; i < arrayArqPastas.length; i++) {
        if (JSON.stringify(pastaAntes) !== JSON.stringify(pastaDepois)) {
          contador++;
          pastaAntes = pastaDepois;
        }

        if (i === arrayArqPastas.length - 2 && arrayArqPastas.length >= 4) {
          newArray.push(arrayArqPastas[i] + "###----" + contador);
        } else {
          newArray.push(arrayArqPastas[i]);
        }
      }

      arrayArqPastas = newArray;

      if (
        arrayArqPastas.length == 1 &&
        treeItens.findIndex((item) => item.id == "0") >= 0
      ) {
        idParent = null;
      }

      for (const item of arrayArqPastas) {
        if (!item.includes(".") && arrayArqPastas.length > 1) {
          idParent = await incluirNovaPasta(item, idParent);
        } else {
          incluirNovoArquivo(
            arq.nomeOriginal,
            idParent,
            arq.tamanho,
            arq.urlArquivo,
            arq.path,
            arq.tipo,
            arq.nomeOriginal,
            arq.extensao,
            arq.urlPreview
          );
        }
      }
    }

    setTimeout(() => {
      setUploadFinalizar(true);
      setShowProgresso(false);
      setShowUpload(false);
    }, 100);
  };
  const formatNomePasta = (nome) => {
    if (nome.length > 20) {
      return nome.slice(0, 20) + "...";
    }
    return nome;
  };
  const onLoadData = ({ key, children }) =>
    new Promise((resolve) => {
      if (children) {
        resolve();
        return;
      }
      if (key == "0") {
        setTimeout(() => {
          const array = [];
          listaPastaArquivosCriados.forEach((item) => {
            if (!item.idParent) {
              array.push({
                title: formatNomePasta(item.nome),
                key: item.id,
                isLeaf: item.nome.includes("."),
                icon: item.nome.includes(".") ? (
                  <img
                    className="icon-tree"
                    src={item.urlPreview ? item.urlPreview : infoArquivoSvg}
                  />
                ) : (
                  <img className="icon-tree" src={pastaSvg} />
                ),
              });
            }
          });
          setTreeItens((origin) => updateTreeData(origin, key, array));
          resolve();
        }, 2000);
      } else {
        setTimeout(() => {
          const array = [];
          listaPastaArquivosCriados.forEach((item) => {
            if (item.idParent == key) {
              array.push({
                title: formatNomePasta(item.nome),
                key: item.id,
                isLeaf: item.nome.includes("."),
                icon: item.nome.includes(".") ? (
                  <img
                    className="icon-tree"
                    src={item.urlPreview ? item.urlPreview : infoArquivoSvg}
                  />
                ) : (
                  <img className="icon-tree" src={pastaSvg} />
                ),
              });
            }
          });
          setTreeItens((origin) => updateTreeData(origin, key, array));
          resolve();
        }, 2000);
      }
    });

  const dummyRequest = ({ file, onSuccess }) => {
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  };

  const finalizar = async (listaTotal, listaNova) => {
    if (listaNova.length >= listaTotal.length) {
      await uploadArquivo();
    }
  };

  const uploadArquivo = async () => {
    let url;
    let pastaDestino = "nuvem_arquivo";

    if (destino) {
      pastaDestino = destino.id;
    }

    for (const arquivo of listaArquivos) {
      let index = listaArquivos.findIndex((item) => item.nome == arquivo.nome);
      setCount(index + 1);

      if (arquivo.tipo.includes("image")) {
        let response = await uploadArquivoAzure(
          arquivo.file,
          pastaDestino,
          300,
          300,
          handleUploadProgress
        );
        if (!response.fail && response.data) {
          var result = response.data;
          url = `${AZURE_URL_BLOB}${pastaDestino}/${result}`;
          var extensao = path.extname(arquivo.file.name);

          var original = path.basename(result, path.extname(result)) + extensao;
          original = url.replace(result, original).replace("THUMB_", "");
          atualizarListaArquivo(original, index, url);
        }
      } else {
        let response = await uploadAzure(
          arquivo.nome,
          arquivo.file,
          arquivo.tamanho,
          pastaDestino,
          handleUploadProgress
        );

        if (response._response.status == 201) {
          url = response._response.request.url;
          atualizarListaArquivo(url, index, null);
        }
      }
    }

    setTimeout(() => {}, 20);

    await monstarUploadFinalizacao();
  };

  const atualizarListaArquivo = (url, index, urlPreview) => {
    listaArquivos[index].urlArquivo = url;
    listaArquivos[index].urlPreview = urlPreview;
    setListaArquivos(listaArquivos);
  };

  const alterarImagem = (file) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        300,
        300,
        "JPEG",
        100,
        0,
        (uri) => {
          return resolve(uri);
        },
        "file",
        100,
        100
      );
    });

  const propsDraggerPasta = {
    name: "pasta",
    multiple: true,
    directory: true,
    customRequest: dummyRequest,
    onChange: async ({ file }) => {
      if (file.status == "done") {
        let arquivo = {
          nome: file.originFileObj.webkitRelativePath
            ? file.originFileObj.webkitRelativePath
            : file.nome,
          tamanho: file.size,
          tipo: file.type,
          file: file.originFileObj,
          urlArquivo: "",
          path: file.originFileObj.webkitRelativePath,
          nomeOriginal: file.name,
          extensao: path.extname(file.name).slice(1),
        };

        listaArquivos.push(arquivo);
        setListaArquivos(listaArquivos);
        await finalizar(listaTotal, listaArquivos);
      }
    },
    onDrop(e) {},
  };

  const propsDraggerArquivo = {
    name: "arquivo",
    multiple: true,
    customRequest: dummyRequest,
    onChange: async ({ file }) => {
      if (file.status == "done") {
        let arquivo = {
          nome: file.originFileObj.webkitRelativePath
            ? file.originFileObj.webkitRelativePath
            : file.name,
          tamanho: file.size,
          tipo: file.type,
          file: file.originFileObj,
          urlArquivo: "",
          path: file.originFileObj.webkitRelativePath,
          nomeOriginal: file.name,
          extensao: path.extname(file.name).slice(1),
          urlPreview: null,
        };
 

        listaArquivos.push(arquivo);
        setListaArquivos(listaArquivos);
        await finalizar(listaTotal, listaArquivos);
      }
    },
    onDrop(e) { 
    },
  };

  const handleBackgroundClick = (event) => {
    if (event.target.classList.contains("ant-modal-wrap") && showProgresso) {
      message.warning(
        "Tem certeza que deseja sair? Clique no X e o upload será cancelado."
      );
    }
  };

  function fecharModal() {
    if (showProgresso) {
      setCloseOpenModal(false);
      message.success("Upload cancelado com sucesso.");
    }
  }

  function naoSubstituir() {
    closeModal();
  }
  return (
    <div onMouseDown={handleBackgroundClick}>
      <Modal
        title={
          uploadFinalizar && !arquivoDuplicado ? (
            <span className="modal-title-uplfinalizado ">
              Finalizando o upload
            </span>
          ) : showProgresso ? (
            <span className="modal-title-uploadAndamento">
              Upload em andamento
            </span>
          ) : (
            <span className="modal-title-upload"></span>
          )
        }
        visible={openModal}
        className={
          uploadFinalizar && !arquivoDuplicado
            ? "modal-novo"
            : showProgresso
            ? "modal-novo-uploadContagem"
            : arquivoDuplicado
            ? "modal-novo-lixeira"
            : "modal-novo-upload"
        }
        maskClosable={false}
        closable={false}
        footer={[
          <>
            {uploadFinalizar && !arquivoDuplicado && (
              <div className="buttons-finalizar-upload mt-4 mb-3">
                <button
                  onClick={async () => {
                    await finalizarUpload(true);
                  }}
                  className="button-publicar-mim-upload"
                  disabled={loading}
                >
                  PUBLICAR PARA MIM
                </button>
                <button
                  onClick={async () => {
                    await finalizarUpload(false);
                  }}
                  className="button-publicar-todos-upload"
                  disabled={loading}
                >
                  PUBLICAR PARA TODOS
                </button>
              </div>
            )}
          </>,
        ]}
        destroyOnClose={true}
      >
        <CloseOutlined
          onClick={showProgresso ? fecharModal : closeModal}
          className="custom-close-icon"
        />
        <>
          {showUpload && (
            <div
              className="row"
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Dragger
                {...propsDraggerPasta}
                beforeUpload={(file) =>
                  setListaTotal((prevent) => [...prevent, file])
                }
              >
                {showProgresso ? (
                  <span>
                    <span className="progresso-upload-contagem">
                      {progressoUpload}
                      <span>%</span>{" "}
                    </span>
                    <span className="upload-contagem">
                      {`Upload ${count} de ${listaTotal.length}`}
                    </span>
                  </span>
                ) : (
                  <>
                    <div>
                      <div>
                        <SearchOutlined className="search-icon" />
                      </div>
                      <div className="pesquisar-arquivo">
                        <div className="button-pesquisar">Pesquisar pasta</div>
                      </div>
                    </div>
                  </>
                )}
              </Dragger>
              {!showProgresso && (
                <Dragger
                  {...propsDraggerArquivo}
                  beforeUpload={(file) =>
                    setListaTotal((prevent) => [...prevent, file])
                  }
                >
                  <div className="pesquisar-arquivo">
                    <div className="button-pesquisar">Pesquisar arquivo</div>
                  </div>
                </Dragger>
              )}
            </div>
          )}
        </>
        <>
          {uploadFinalizar && !arquivoDuplicado && (
            <div className="container-upload espacoUpload">
              <div className="itens-selecionados-upload  ">
                <div className="itens fundoGray">
                  <label>Destino:</label>
                  <input
                    className="input-upload"
                    value={destino != null ? destino.nome : "Nuvem de arquivos"}
                  />
                </div>
              </div>
              <div className="itens-importados">
                <span className="titulo-impotados">Arquivos Importados</span>
                <div>
                  <Tree
                    className="lista-pastas"
                    showIcon
                    loadData={onLoadData}
                    onSelect={selectItem}
                    onExpand={handleOnExpand}
                    treeData={treeItens}
                  />
                </div>
              </div>
              <div className="group-data-hora-upload">
                <div className="label-input">
                  <label className="label-data-inicio-upload">Início</label>
                  <label className="label-data-fim-upload">Fim</label>
                  <br />

                  <input
                    disabled={IsAdmin.toLocaleLowerCase() != "true"}
                    className="input-data-arquivo-upload "
                    type="date"
                    onChange={(e) =>
                      setDataVencimentoInicial(
                        moment(e.target.value).format("YYYY-MM-DD")
                      )
                    }
                    value={moment(dataVencimentoInicial).format("YYYY-MM-DD")}
                  />
                  <input
                    disabled={IsAdmin.toLocaleLowerCase() != "true"}
                    className="input-hora-arquivo"
                    type="time"
                    onChange={(e) => setHoraInicial(e.target.value)}
                    value={horaInicial}
                  />

                  <input
                    disabled={IsAdmin.toLocaleLowerCase() != "true"}
                    className="input-data-arquivo-upload "
                    type="date"
                    onChange={(e) => setDataVencimentoFinal(e.target.value)}
                    value={dataVencimentoFinal}
                  />
                  <input
                    disabled={IsAdmin.toLocaleLowerCase() != "true"}
                    className="input-hora-arquivo"
                    type="time"
                    onChange={(e) => setHoraFinal(e.target.value)}
                    value={horaFinal}
                  />
                </div>
              </div>
            </div>
          )}
        </>
        <>
          {arquivoDuplicado && (
            <>
              <div className="container-confirmacao-galeria">
                <img
                  src={icAtencao}
                  style={{ width: 150, height: 150, marginLeft: "46px" }}
                />
                <div className="text-certeza-lixeira">
                  {" "}
                  <span>
                    Identificamos arquivo(s) com mesmo nome na pasta de destino.
                  </span>
                </div>
                <div className="text-aviso-lixeira">
                  <span></span>
                </div>
              </div>

              <div className="container-buttons">
                <button
                  onClick={naoSubstituir}
                  className="button-modal-novo"
                  disabled={loading}
                >
                  CANCELAR
                </button>
                <button
                  onClick={async () =>
                    await finalizarUpload(botaoParamimTodos, true)
                  }
                  className="buttonConfirmar-modal-novo"
                  disabled={loading}
                >
                  SUBSTITUIR
                </button>
              </div>
            </>
          )}
        </>
      </Modal>
    </div>
  );
};

export default ModalUpload;
